export const API_BASE_URL =
  import.meta.env.VITE_GEEKLLY_API_BASE_URL ||
  globalThis.window?.GEEKLLY_API_BASE_URL ||
  'https://api.geeklly.top';

export const apiEndpoint = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const API_ENDPOINTS = {
  auth: {
    login: apiEndpoint('/api/auth/login'),
    session: apiEndpoint('/api/auth/session'),
    logout: apiEndpoint('/api/auth/logout'),
    turnstile: apiEndpoint('/api/auth/turnstile')
  },
  chat: apiEndpoint('/api/chat'),
  summary: apiEndpoint('/api/summary'),
  translate: apiEndpoint('/api/translate'),
  pi: {
    list: () => apiEndpoint(`/api/admin/pi-list?t=${Date.now()}`),
    preview: (id) => apiEndpoint(`/api/admin/pi-preview?id=${encodeURIComponent(id)}&format=jpg&t=${Date.now()}`),
    update: apiEndpoint('/api/admin/update-pi'),
    save: apiEndpoint('/api/save-pi'),
    event: apiEndpoint('/api/pi-event')
  },
  radar: {
    activity: () => apiEndpoint(`/api/admin/check-activity?t=${Date.now()}`),
    ipInfo: (ip) => apiEndpoint(`/api/proxy-ipinfo?ip=${encodeURIComponent(ip)}`)
  },
  alerts: {
    settings: apiEndpoint('/api/alerts/settings'),
    rules: apiEndpoint('/api/alerts/rules'),
    updateRule: (id) => apiEndpoint(`/api/alerts/rules/${encodeURIComponent(id)}`),
    testEmail: apiEndpoint('/api/alerts/test-email'),
    events: (limit = 20) => apiEndpoint(`/api/alerts/events?limit=${encodeURIComponent(limit)}&t=${Date.now()}`)
  },
  conversations: {
    upsert: apiEndpoint('/api/conversations/upsert'),
    list: (params = {}) => {
      const query = new URLSearchParams({ t: Date.now().toString() });
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
      });
      return apiEndpoint(`/api/conversations?${query.toString()}`);
    },
    detail: (id) => apiEndpoint(`/api/conversations/${encodeURIComponent(id)}?t=${Date.now()}`),
    messages: (id, params = {}) => {
      const query = new URLSearchParams({ t: Date.now().toString() });
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
      });
      return apiEndpoint(`/api/conversations/${encodeURIComponent(id)}/messages?${query.toString()}`);
    },
    createMessage: (id) => apiEndpoint(`/api/conversations/${encodeURIComponent(id)}/messages`)
  },
  piAutopilot: {
    products: (includeRules = false) => apiEndpoint(`/api/products?includeRules=${includeRules ? '1' : '0'}&t=${Date.now()}`),
    createProduct: apiEndpoint('/api/products'),
    updateProduct: (id) => apiEndpoint(`/api/products/${encodeURIComponent(id)}`),
    priceBooks: (productId = '') => {
      const query = new URLSearchParams({ t: Date.now().toString() });
      if (productId) query.set('productId', productId);
      return apiEndpoint(`/api/price-books?${query.toString()}`);
    },
    createPriceBook: apiEndpoint('/api/price-books'),
    updatePriceBook: (id) => apiEndpoint(`/api/price-books/${encodeURIComponent(id)}`),
    paymentTerms: () => apiEndpoint(`/api/payment-terms?t=${Date.now()}`),
    deliveryTerms: () => apiEndpoint(`/api/delivery-terms?t=${Date.now()}`),
    preparePi: apiEndpoint('/api/agent/actions/prepare-pi'),
    validateDraft: (id) => apiEndpoint(`/api/pi-drafts/${encodeURIComponent(id)}/validate`),
    approveAndConvert: (id) => apiEndpoint(`/api/pi-drafts/${encodeURIComponent(id)}/approve-and-convert`)
  },
  agent: {
    ask: apiEndpoint('/api/agent/ask'),
    rewriteIntent: apiEndpoint('/api/agent/rewrite-intent'),
    nextAction: apiEndpoint('/api/agent/next-action'),
    riskCheck: apiEndpoint('/api/agent/risk-check'),
    customerSettings: apiEndpoint('/api/agent/customer-settings'),
    customerCopilot: apiEndpoint('/api/agent/customer-copilot'),
    contactFinder: apiEndpoint('/api/agent/contact-finder'),
    commandCenter: apiEndpoint('/api/agent/command-center'),
    inquiryClassify: apiEndpoint('/api/agent/inquiries/classify'),
    cultureAdvisor: apiEndpoint('/api/agent/culture-advisor/analyze'),
    serviceValueReport: apiEndpoint('/api/reports/merchant-service-value-report/generate'),
    bossDailyReport: apiEndpoint('/api/agent/boss-daily-report/generate'),
    qualityAudit: apiEndpoint('/api/agent/quality-audit/run'),
    tasks: apiEndpoint('/api/agent/tasks')
  },
  leadFilter: {
    scan: apiEndpoint('/api/lead-filter/scan'),
    rules: apiEndpoint('/api/lead-filter/rules'),
    updateRule: (id) => apiEndpoint(`/api/lead-filter/rules/${encodeURIComponent(id)}`),
    review: apiEndpoint('/api/lead-filter/review')
  },
  upload: (filename) => apiEndpoint(`/${filename}`)
};
